import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

export default function ModalBody(props) {
	const { children, className, ...rest } = props;
	return (
		<div className={cx('c-modal-body', className)} {...rest}>
			{children}
		</div>
	);
}
ModalBody.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};
